import React from "react";

interface RectanglePlusIconProps {
  size?: string;
  color?: string;
}

const RectanglePlusIcon = ({ size = "80", color = "#5A8DF1" }: RectanglePlusIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="77"
        height="77"
        rx="2.5"
        stroke={color}
        strokeWidth="3"
      />
      <path
        d="M40 27.3077V52.6923M27.3077 40H52.6923"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RectanglePlusIcon;